import * as types from "./types";

export const addArrFlashCardRequest = (payload) => ({
  type: types.ADD_ARR_FLASH_CARD_REQUEST,
  payload
});
export const addArrFlashCardResponse = (payload) => ({
  type: types.ADD_ARR_FLASH_CARD_RESPONSE,
  payload
});

export const getAllFlashCardRequest = (payload) => ({
  type: types.GET_ALL_FLASH_CARD_REQUEST,
  payload
});
export const getAllFlashCardResponse = (payload) => ({
  type: types.GET_ALL_FLASH_CARD_RESPONSE,
  payload
});

export const getSingleFlashCardRequest = (payload) => ({
  type: types.GET_SINGLE_FLASH_CARD_REQUEST,
  payload
});
export const getSingleFlashCardResponse = (payload) => ({
  type: types.GET_SINGLE_FLASH_CARD_RESPONSE,
  payload
});

export const editSingleFlashCardRequest = (payload) => ({
  type: types.EDIT_SINGLE_FLASH_CARD_REQUEST,
  payload
});

export const deleteSingleFlashCardRequest = (payload) => ({
  type: types.DELETE_SINGLE_FLASH_CARD_REQUEST,
  payload
});

export const deleteSingleFlashCardResponse = (payload) => ({
  type: types.DELETE_SINGLE_FLASH_CARD_RESPONSE,
  payload
});

export const setFlashcardtSearch = (data) => ({
  type: types.SET_FLASH_CARD_SEARCH,
  payload: data
});

export const setFlashcardtsPage = (payload) => ({
  type: types.SET_FLASH_CARD_PAGE,
  payload
});
